import { Fab, SpeedDialIcon, Tooltip, useTheme } from '@mui/material';
import { FC } from 'react';

type AddBlockButton = {
  onClick: () => void;
};

const AddBlockButton: FC<AddBlockButton> = (props) => {
  const theme = useTheme();

  return (
    <Tooltip title='New Block...' placement='left'>
      <Fab
        size='medium'
        color='primary'
        onClick={props.onClick}
        sx={{
          position: 'absolute',
          bottom: theme.spacing(2),
          right: theme.spacing(2)
        }}
      >
        <SpeedDialIcon />
      </Fab>
    </Tooltip>
  );
};

export default AddBlockButton;
